module.exports = __webpack_public_path__ + "static/01-96b48f2b3e9cc17b6173bb7b5f9497f7.jpg";